import React from "react";
import { Link } from "react-router-dom";
import { Profile } from "../../../stores/ProfileStore/Types";
import { SubscriptionIcon } from "./Icons";

interface Props {
  profileResource: Profile;
}

const Subscription: React.FC<Props> = ({ profileResource }) => {
  if (!profileResource.subscription) {
    return (
      <Link
        className="wstat"
        id="wstatSub"
        data-tip-wrap
        to="/passes/month/pay"
        data-tip="You are on the free plan. Tap to see plans."
      >
        <span className="wstat-ic sub is-none">
          <svg aria-hidden="true">
            <use href="#ln-crown" />
          </svg>
        </span>
        <span className="wstat-label">
          <span className="lbl-full">Subscription</span>
          <span className="lbl-short">Subs</span>
        </span>
        <span className="wstat-value" id="wstatSubValue">
          <span className="val-full">Upgrade</span>
          <span className="val-short">Upgrade</span>
        </span>
      </Link>
    );
  }

  if (!profileResource?.subscription?.active) {
    return (
      <Link
        className="wstat"
        id="wstatSub"
        data-tip-wrap
        data-tip="Your subscription has ended. Tap to renew."
        to={
          profileResource.subscription.interval === "month"
            ? "/pass/month/renew"
            : "/pass/year/renew"
        }
      >
        <span className="wstat-ic sub is-none">
          <svg aria-hidden="true">
            <use href="#ln-crown" />
          </svg>
        </span>
        <span className="wstat-label">
          <span className="lbl-full">Subscription</span>
          <span className="lbl-short">Subs</span>
        </span>
        <span className="wstat-value" id="wstatSubValue">
          <span className="val-full">Renew</span>
          <span className="val-short">Renew</span>
        </span>
      </Link>
    );
  }

  if (profileResource?.subscription?.is_community) {
    return (
      <Link
        to="/passes/month/pay"
        className="wstat"
        id="wstatSub"
        data-tip-wrap
        data-tip="Community member. Tap to upgrade to All Access."
      >
        <span className="wstat-ic sub is-community">
          <svg aria-hidden="true">
            <use href="#ln-crown"></use>
          </svg>
        </span>
        <span className="wstat-label">
          <span className="lbl-full">Subscription</span>
          <span className="lbl-short">Subs</span>
        </span>
        <span className="wstat-value">
          <span className="val-full">Community</span>
          <span className="val-short">Hub</span>
        </span>
      </Link>
    );
  }

  return (
    <Link
      to="#"
      className="wstat"
      id="wstatSub"
      data-tip-wrap
      data-tip="All Access Pass. Tap to manage your plan."
    >
      <span className="wstat-ic sub is-allaccess">
        <svg aria-hidden="true">
          <use href="#ln-crown"></use>
        </svg>
      </span>
      <span className="wstat-label">
        <span className="lbl-full">Subscription</span>
        <span className="lbl-short">Subs</span>
      </span>
      <span className="wstat-value">
        <span className="val-full">All Access</span>
        <span className="val-short">Pass</span>
      </span>
    </Link>
  );
};

export default Subscription;
